import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import { getMe } from "@/api/auth";
import { useAuthStore } from "@/stores/auth";

const NO_AREAS = [];

// The current user's effective grants for UI gating. Backend enforces the same rules, so this only
// hides/disables what the user can't do. An owner is "full" and can() is always true for them
// (from /auth/me; token artık kalıcı değil, açılışta refresh ile geliyor) — a branch manager's
// permissions come from /me.
export function useAccess() {
  const user = useAuthStore((s) => s.user);
  const { data, isError, refetch } = useQuery({
    queryKey: ["me"],
    queryFn: getMe,
    staleTime: 5 * 60 * 1000,
  });

  const role = data?.role ?? user?.role;
  // superadmin BURADA full DEĞİL: kiracı kapsamı yok ve kiracı uçları ona 403 dönüyor
  // ("Superadmin must act through impersonation"). Full saymak panelin o sayfaları açmasına
  // yol açıyordu; sayfa yükleniyor, her sorgusu 403 ile düşüyor ve hata kaydına yazılıyordu.
  // Impersonation sırasında token'daki rol zaten 'owner', yani partner gibi gezerken full.
  const isFull = role === "owner";
  const areas = data?.areas ?? NO_AREAS;
  const allBranches = isFull || data?.branchIds === null;

  // Hook liste satırlarının her birinden çağrılıyor; dönüş referansı sabit kalmazsa her render
  // yeni closure üretir ve memo/dep dizileri işlevsizleşir.
  return useMemo(
    () => ({
      isFull,
      allBranches,
      // Yetki kararı verilebilir mi? owner/superadmin store'daki rolden anında belli olur;
      // şube müdürünün izinleri /me ile gelir. Yönlendirme yapan yerler bunu beklemeli, yoksa
      // yetkili kullanıcı sayfa yenilemede bir an dışarı atılır.
      loaded: isFull || Boolean(data),
      // /me bir hatayla düşerse (401 dahil — interceptor onu da yenilemeye çalışır) loaded sonsuza dek false kalırdı: boş ekran, hata
      // mesajı yok, tekrar deneme yok. Çağıran taraf bunu görüp açık bir hata gösterebilsin.
      failed: isError && !data,
      retry: refetch,
      can: (area) => isFull || areas.includes(area),
      canAny: (required) =>
        isFull || required.some((area) => areas.includes(area)),
    }),
    [allBranches, areas, data, isError, isFull, refetch],
  );
}
